module.exports = __webpack_public_path__ + "static/media/travel14.1499889c.jpg";